import { useQuery } from "@tanstack/react-query";
import { healthService } from "@/services/healthService";

export function useLiveness() {
  return useQuery({ queryKey: ["health", "liveness"], queryFn: healthService.getLiveness });
}

export function useReadiness() {
  return useQuery({ queryKey: ["health", "readiness"], queryFn: healthService.getReadiness });
}
